export function removeWhiteSpace(url) {
  return url.trim();
}
export function replaceSpecialCharacters() {}

export function extractNestedValue(data, fieldkey) {
  let values = [];
  function extract(obj, arr, key) {
    if (typeOf(obj) === "object") {
      Object.entries(obj).forEach(([k, v]) => {
        if (typeOf(v) === "object" || typeOf(v) === "array") {
          extract(v, arr, key);
        } else if (k === key) {
          arr.push(v);
        }
      });
    } else if (typeOf(obj) === "array") {
      obj.forEach((item) => {
        extract(item, arr, key);
      });
    }
    return arr;
  }
  return extract(data, values, fieldkey);
}

export function typeOf(value) {
  if (Array.isArray(value)) {
    return "array";
  }
  return typeof value;
}

export function readApplicationConfigurationFromDOM(id) {
  try {
    const applicationSettings = document.getElementById(id).value;
    const config = JSON.parse(applicationSettings);
    return config;
  } catch (error) {
    console.error(`Could not read application-settings`);
  }
  // console.log("applicationSettings", applicationSettings);
  // const config = JSON.parse(applicationSettings);
}

export function extractFieldNameFromSubject(subject) {
  const valueRegexp = /\{\{(.*)\}\}/;
  return subject.match(valueRegexp)
    ? subject.match(valueRegexp)[1]
    : "kunde inte hitta fält";
}

/**
 * this function is used until we have migrated to launch for 3kronor.se
 * since there is no aliasing for DTM()
 */
export function getTrackingScriptSrc() {
  const { hostname } = window.location;
  switch (hostname) {
    case "localhost":
      return "//assets.adobedtm.com/42c2af5ee3bc01c325da04f3aaa8cf5d6ae2e268/satelliteLib-08d76646e40d2445b97a141a46d5129a97843db2-staging.js";
    // return "/satelliteLib.js";
    case "www.3kronor.se":
      return "//assets.adobedtm.com/42c2af5ee3bc01c325da04f3aaa8cf5d6ae2e268/satelliteLib-08d76646e40d2445b97a141a46d5129a97843db2.js";
    default:
      return "//assets.adobedtm.com/42c2af5ee3bc01c325da04f3aaa8cf5d6ae2e268/satelliteLib-08d76646e40d2445b97a141a46d5129a97843db2-staging.js";
  }
}

/**
 * https://stackoverflow.com/questions/19098797/fastest-way-to-flatten-un-flatten-nested-json-objects
 */
export function flattenObject(data) {
  var result = {};
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++)
        recurse(cur[i], prop + "[" + i + "]");
      if (l == 0) result[prop] = [];
    } else {
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "." + p : p);
      }
      if (isEmpty && prop) result[prop] = {};
    }
  }
  recurse(data, "");
  return result;
}
